'use client';

import { FC } from 'react';

import { ShoppingCartItem } from '@ravago/shared/page-data/models/features';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Dialog } from '@ravago/shared/radiance/components/dialog/components/Dialog/Dialog';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   shoppingCartItem: ShoppingCartItem;
   removeFromShoppingCart: (shoppingCartItemId: number) => void;
   onDialogClose: () => void;
}

export const ShoppingCartRemoveItemDialogElement: FC<Props> = ({ removeFromShoppingCart, shoppingCartItem, onDialogClose }) => {
   const translate = useTranslations();
   const handleRemoveFromCart = async (cartItemId: ShoppingCartItem['id']) => {
      removeFromShoppingCart(cartItemId);
      onDialogClose();
   };

   return (
      <Dialog
         open
         closeOnOutsideClick
         onDialogClose={onDialogClose}
         title={translate('shopping-cart.remove')}
         actions={
            <Box direction="row">
               <Typography align="right">
                  <Button variant="secondary" onClick={onDialogClose}>
                     {translate('shopping-cart.cancel')}
                  </Button>
               </Typography>
               <Typography align="right">
                  <Button variant="primary" onClick={() => handleRemoveFromCart(shoppingCartItem.id)}>
                     <Icon icon="trash" /> {translate('shopping-cart.remove-item')}
                  </Button>
               </Typography>
            </Box>
         }
      >
         <Typography color="subtle" component="span" variant="body">
            {translate('shopping-cart.remove-description', { itemName: shoppingCartItem.product.description })}
         </Typography>
      </Dialog>
   );
};
